import React from 'react';
import {ReactComponent as FlaskSvg} from '../svg/flask.svg';
import {ReactComponent as MysqlSvg} from '../svg/mysql.svg';
import {ReactComponent as NginxSvg} from '../svg/nginx.svg';
import {ReactComponent as PythonSvg} from '../svg/python.svg';
import {ReactComponent as SemanticSvg} from '../svg/semantic-ui.svg';
import {ReactComponent as TypeScriptSvg} from '../svg/typescript-icon.svg';
import {ReactComponent as UbuntuSvg} from '../svg/ubuntu.svg';


function Icons() {

  return (
    <div className="Icons">
        <h3>Tech Stack</h3>
        <div className="icons">
          <FlaskSvg />
          <MysqlSvg />
          <NginxSvg />
          <PythonSvg />
          <SemanticSvg />
          <TypeScriptSvg />
          <UbuntuSvg />
        </div>
    </div>
  );
}

export default Icons;
